// Script for Shrink Txt
$(document).ready(function() {

  // Product Title
  $(".shrinkable-productTitle").hover(
    function() {
      $(this).addClass("showFull");
    },
    function() {
      $(this).removeClass("showFull");
    }
  );

});